import { createFileRoute } from "@tanstack/react-router";
import { Methode } from "../components/sections";
import { pageHead } from "@/lib/seo";

const TITLE = "Methode — Bestuurde architectuur | IT Solutions";
const DESC =
  "Hoe wij bouwen: governance, drievoudig review-proces, semver-releases, RLS-databasebeveiliging. 27 live projecten in 45 dagen, ~453.000 regels eigen code.";

import { MethodePage } from "@/pages/methode";

export const Route = createFileRoute("/methode")({
  head: () =>
    pageHead({ lang: "nl", pathWithoutLang: "/methode", title: TITLE, description: DESC }),
  component: MethodePage,
});
